import { createPortal } from 'react-dom';
import { usePageTitleSlot } from '../context/PageTitleContext.jsx';

// A page's title, shown in the app header (left of the search bar) rather than
// where it's rendered. Use it once per page, in place of a heading:
//   <PageTitle>{typeIcons.account} {account.name_short}</PageTitle>
const PageTitle = ({ children }) => {
  const slot = usePageTitleSlot();
  return slot ? createPortal(<h2 className="page-title">{children}</h2>, slot) : null;
};

export default PageTitle;
